import { useAuth } from "@/contexts/AuthContext";
import { useGame, BUILDING_COIN_INCOME } from "@/contexts/GameContext";
import { useTheme } from "@/contexts/ThemeContext";

export default function StatsOverview() {
  const { user } = useAuth();
  const { blocks } = useGame();
  const { isDark } = useTheme();

  const myBlocks = user
    ? Object.values(blocks).filter((b) => b.ownerId === user.id)
    : [];

  const totalBuildings = myBlocks.reduce((sum, b) => sum + b.buildings.length, 0);
  const hourlyIncome = myBlocks.reduce((sum, b) => {
    return sum + b.buildings.reduce((s, bld) => s + BUILDING_COIN_INCOME[bld.type], 0);
  }, 0);
  const forSaleCount = myBlocks.filter((b) => b.isForSale).length;

  const stats = [
    {
      icon: "ri-map-pin-2-line",
      label: "所有区画",
      value: myBlocks.length,
      unit: "区画",
      color: "text-amber-400",
      bg: "bg-amber-400/10",
      border: "border-amber-400/20",
    },
    {
      icon: "ri-building-2-line",
      label: "建設済み建物",
      value: totalBuildings,
      unit: "棟",
      color: "text-emerald-400",
      bg: "bg-emerald-400/10",
      border: "border-emerald-400/20",
    },
    {
      icon: "ri-coin-line",
      label: "コイン残高",
      value: user?.coins.toLocaleString() ?? "0",
      unit: "coins",
      color: "text-yellow-400",
      bg: "bg-yellow-400/10",
      border: "border-yellow-400/20",
    },
    {
      icon: "ri-time-line",
      label: "時間収入",
      value: hourlyIncome,
      unit: "coins/h",
      color: "text-sky-400",
      bg: "bg-sky-400/10",
      border: "border-sky-400/20",
    },
    {
      icon: "ri-auction-line",
      label: "出品中",
      value: forSaleCount,
      unit: "区画",
      color: "text-orange-400",
      bg: "bg-orange-400/10",
      border: "border-orange-400/20",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
      {stats.map((s) => (
        <div
          key={s.label}
          className={`rounded-2xl border p-5 flex flex-col gap-3 transition-all ${s.border} ${isDark ? "bg-white/3" : "bg-white"} ${s.bg}`}
        >
          <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${s.bg}`}>
            <i className={`${s.icon} text-xl ${s.color}`}></i>
          </div>
          <div>
            <p className={`text-2xl font-black ${s.color}`}>{s.value}</p>
            <p className={`text-xs mt-0.5 ${isDark ? "text-gray-500" : "text-gray-400"}`}>{s.unit}</p>
          </div>
          <p className={`text-xs font-medium ${isDark ? "text-gray-400" : "text-gray-500"}`}>{s.label}</p>
        </div>
      ))}
    </div>
  );
}
